const menusService = [
   {
        "title": "monthly report",
        "url": "monthly",
        "default": "/summary",
        "subMenus": [
            {
                "title": "summary",
                "url": "summary"
            },
            {
                "title": "yearly actuals vs budget",
                "url": "ya_vs_budget",
                "input": true
            },
            {
                "title": "yearly actuals vs prior year",
                "url": "ya_vs_py"
            },
            {
                "title": "quarterly actuals",
                "url": "quarterly"
            }
        ]
    },
    {
        "title": "individual Performance",
        "url": "employees",
        "default": "/summary",
        "subMenus": [
            {
                "title": "summary",
                "url": "summary"
            },
            {
                "title": "quarterly actuals",
                "url": "quarterly"
            },
            {
                "title": "actuals vs budget",
                "url": "actuals_vs_budget",
                "input": true
            }
        ]
    }
];

export default menusService;
